module.exports = __webpack_public_path__ + "static/media/arrow.7bf481f9.svg";